Vue.filter('date', function (value) {
  if (!value && value.format()) return '';
  return `${value.format('DD/MM/YYYY')}`;
});

Vue.filter('dayAndDate', function (value) {
  if (!value && value.format()) return '';
  return `${value.format('dddd DD/MM/YYYY')}`;
});

Vue.filter('dayDateAndTime', function (departureTime, arrivalTime) {
  if (!departureTime || !arrivalTime) return '';

  const startDateTime = departureTime.format('DD/MM/YYYY · H:mm');
  const endDateTime = arrivalTime.format('H:mm');

  return `${startDateTime} - ${endDateTime}`;
});